import React from 'react';
import { useTranslation } from 'react-i18next';
import type { OriginalFetchJob } from '../services/documentFetchService';
import './OriginalFetchProgress.css';

interface OriginalFetchProgressProps {
  job: OriginalFetchJob;
  onCancel: () => void;
}

/**
 * Thin filling bar shown in a document row while its original PDF is being
 * retrieved in the background. Determinate for patents once the EPO inquiry
 * has returned the page count; indeterminate before that and for scientific
 * publications (source counts are meaningless to users).
 */
const OriginalFetchProgress: React.FC<OriginalFetchProgressProps> = ({ job, onCancel }) => {
  const { t } = useTranslation();
  const { done, total, unit } = job.progress;
  const determinate = unit === 'pages' && total != null && total > 0;
  const pct = determinate ? Math.min(100, Math.round((done / (total as number)) * 100)) : 0;
  const label =
    job.status === 'cancelling'
      ? t('kbDocuments.fetchCancelling')
      : unit === 'pages'
        ? total
          ? t('kbDocuments.fetchProgressPages', { pages: total })
          : t('kbDocuments.fetchContactingEpo')
        : t('kbDocuments.fetchSearchingSources');
  return (
    <div className="original-fetch-progress" title={label}>
      <div className={`ofp-bar${determinate ? '' : ' ofp-indeterminate'}`}>
        <div className="ofp-fill" style={determinate ? { width: `${pct}%` } : undefined} />
      </div>
      <span className="ofp-label">{label}</span>
      <button type="button" className="ofp-cancel" onClick={onCancel} title={t('kbDocuments.fetchCancel')}>
        ×
      </button>
    </div>
  );
};

export default OriginalFetchProgress;
